<template>
    <div class="button-clear"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7 288 416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7 64 416c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 118.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96l0 118.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96l0 320c0 12.4-7.2 23.7-18.4 29z"/></svg> <span> Borrar</span></div>
</template>

<style lang="sass" scoped>
div
    display: flex
    align-items: center
    min-width: 20px    
    color: white
    padding: 0.5rem
    /* border-radius: 0.375rem */
    display: inline-flex
    align-items: center
    justify-content: center
    transition: background-color 0.15s ease-in-out
    span
        
        // margin-left: 7px
        min-width: 66px
        font-size: 0.9em
    svg 
    
        min-width: 20px
        max-width: 20px
    svg 
        fill: #fff

.button-clear 
    min-width: 20px
    width: 100%
    // background-color: #f94e3b
    border-bottom: 3px solid #f94e3b
    color: white
    padding: 0.5rem
    border-radius: 0.375rem
    display: inline-flex
    align-items: center
    justify-content: center
    transition: background-color 0.15s ease-in-out


.button-clear:hover 
    background-color: #be0303

</style>
